import type { Uuid } from "@/utils/model"

export default (order: "asc" | "desc") =>
  (a: { id: Uuid }, b: { id: Uuid }) => {
    // UUIDs are lowercase hex + fixed hyphen positions → simple lexicographic compare works.
    if (a.id === b.id) {
      return 0
    }
    const asc = a.id < b.id ? -1 : 1

    return order === "asc" ? asc : -asc
  }
